(function () {
    const swiperCarousel = document.querySelectorAll(".ap_carousel");
    if (swiperCarousel.length > 0) {
      swiperCarousel.forEach((carousel,i) => {
        let slides = carousel.querySelectorAll(".swiper-slide");
        if (slides.length > 1) {
          
          let options = {
            loop: true,
            simulateTouch: true,
            centeredSlides: true,
            slidesPerView: 1,
            spaceBetween: 0,
            on: {
              init: function () {
                const event = new Event("swiper-ready");
                window.dispatchEvent(event);
              },
            },
            a11y: {
              containerMessage: "This is a slider", // Message to describe the container
              containerRoleDescriptionMessage: "Slider Container", // Message to provide detailed explanation of the container's role
              nextSlideMessage: "Button for the next slide", // Message for the Next button
              prevSlideMessage: "Button for the previous slide", // Message for the Back button
              paginationBulletMessage: "Button to jump to slide {{index}}", // Message for each pagination button (only available when clickable option is true).
              slideLabelMessage: "Slide {{index}} of {{slidesLength}}", // Message for each slide (indicating which slide out of how many)
              slideRole: "group", // Message to describe the role of the slide
              itemRoleDescriptionMessage: "Slide group", // Message to describe the role of the slide in detail
            },
          };
          let prev = carousel.querySelector(".button--prev");
          let next = carousel.querySelector(".button--next");

          if(prev && next){
            prev.classList.add(`swiper-button-prev-${i}`);
            next.classList.add(`swiper-button-next-${i}`);
            options.navigation = {}; 
            options.navigation.nextEl = `.swiper-button-next-${i}`;
            options.navigation.prevEl = `.swiper-button-prev-${i}`;
          }
          if(carousel.classList.contains('carousel--events')){
            options.slidesPerView = 1;
            options.spaceBetween = 20;
            options.breakpoints ={
              700:{
                  slidesPerView:2,
                  spaceBetween:20,
              },
              1000:{
                  slidesPerView:3,
                  spaceBetween:20,
              },
            }
            options.a11y.containerMessage = "This is a gallery of event images";
          }
          if(carousel.classList.contains('carousel--whatever_next')){
            options.slidesPerView = 1;
            options.spaceBetween = 10;
            options.centeredSlides=false;
            options.loop=false;
            options.breakpoints ={
              700:{
                  slidesPerView:2,
                  centeredSlides:false,
              },
              1000:{ 
                  slidesPerView:3,
                  centeredSlides:false,
              },
              1200:{
                  slidesPerView:4.75,
                  centeredSlides:false,
              }
            }
            options.a11y.containerMessage = "This is a slider of upcoming events";
          }
          if(carousel.classList.contains('carousel--stories')){
            options.slidesPerView = 1;
            options.spaceBetween = 10;
            options.centeredSlides=true;
            options.loop=true;
            options.breakpoints ={
              700:{
                  slidesPerView:3,
                  centeredSlides:false,
              },
              1000:{
                  slidesPerView:4,
                  centeredSlides:false,
              },
            }
            options.a11y.containerMessage = "This is a slider of recent blog posts";
          }
          carousel.carouselInstance = new Swiper(carousel, options);
          
        }
      });
    }
  })();
  